import {combineReducers} from '@modifi/redux'
import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import entityReducer from './entity'
import updateReducer from './update'

export default combineReducers({
  current: entityReducer,
  update: updateReducer,
})

export type CompanyState = {
  // @ts-expect-error to be fixed
  current: EntityState
  update: any
}
